/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import Nav from '../general/nav/nav'
import LoginForm from './loginForm'
import Footer from '../general/footer/footer'
import './loginPage.scss'


export default function LoginPage(props) {
    return (
        <div id="mn-login-page">
            <Nav />
            <LoginForm {...props}/>
            <br/>
            <Footer />
        </div>
    )
}
